import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { string_to_span } from '@/utils/utils_html';
import { LAYOUT_COLUMN__left } from '../layout_base/LAYOUT_COLUMN__left';

interface PROPS {}

export function HEADER__page_title() {
  const { global__page_type } = use_slice_ui(['global__page_type']);
  const { user_task_current } = use_slice_generation(['user_task_current']);

  /*
   *
   */

  function get_generation_name() {
    return `Generation\n${user_task_current.name}`;
  }
  /*
   *
   */

  function render_page_title() {
    let out_map = new Map([
      [ENUM__page_type.USER_TASK, 'User Tasks'],
      [ENUM__page_type.USER_TASK_WITHOUT_PARAMS, 'User Tasks'],
      //
      [ENUM__page_type.COLLECTIONS, 'Collections'],
      [ENUM__page_type.COLLECTIONS_WITHOUT_PARAMS, 'Collections'],

      //
      [ENUM__page_type.GENERATION, get_generation_name()],
      [ENUM__page_type.GENERATION_WITHOUT_PARAMS, get_generation_name()],
      //
      [ENUM__page_type.SEARCH, 'Search'],
      [ENUM__page_type.SETTINGS_USER, 'Settings'],
      [ENUM__page_type.SETTINGS_WORKSPACE, 'Settings'],
    ]);

    let out = out_map.get_value_or_default(global__page_type, 'Unknown: ' + global__page_type);

    return render_block(out);
  }

  function render_block(text: string) {
    return <div className="flex-1 w-full text-sm flex-center border-t border-component-border border-dashed first:border-t-0">{string_to_span(text)}</div>;
  }

  return (
    <LAYOUT_COLUMN__left>
      <div className="size-full flex flex-col text-md text-bar-foreground">{render_page_title()}</div>
    </LAYOUT_COLUMN__left>
  );
}
